// extracted by mini-css-extract-plugin
module.exports = {"summary__item":"M_dd","summary__item__name":"M_df","summary__item__price":"M_dg","summary__col__wrap":"M_dh","summary__quantity":"M_dj"};